import { Link } from "react-router-dom";

import Seo from "../../components/Seo";
import { seoFromPublicPage } from "../../seo/publicPages";
import ArticleLayout from "./ArticleLayout";
import RelatedGuides from "./RelatedGuides";

export default function FoaieParcursCasaServiciuPage() {
  return (
    <>
      <Seo {...seoFromPublicPage("/foaie-parcurs-casa-serviciu")} />
      <ArticleLayout
        eyebrow="Trasee"
        title="Traseul casă–serviciu pe foaia de parcurs: când e personal și când poate fi de lucru"
        lead={'Drumul de acasă la sediu nu e automat „deplasare în interes de serviciu”. În interpretarea ANAF, tur–returul casă–birou poate fi scop personal dacă nu face parte dintr-un traseu de lucru. De aici se joacă 50% sau 100%.'}
      >
        <p>
          Foile de parcurs cad rar pe un detaliu de antet. Cad pe{" "}
          <strong>trasee care nu se leagă de activitate</strong>. Cel mai frecvent e
          drumul pe care îl faci în fiecare dimineață: de acasă la „birou". Îl treci din
          obișnuință ca deplasare de serviciu. La control, poate fi citit ca navetă
          personală.
        </p>
        <p>
          Nu e o interdicție de a pune mașina în evidență. E o întrebare de{" "}
          <strong>regim</strong>: dacă autoturismul face zilnic casă–sediu–mall, fără
          clienți, fără instituții, fără livrări, pretinderea de <strong>100%</strong> e
          greu de susținut. <strong>50%</strong> recunoaște uzul mixt și nu cere foaie.
        </p>

        <h2>De ce e sensibil traseul casă–birou</h2>
        <p>
          Codul Fiscal cere, pentru 100%, <strong>utilizare exclusiv economică</strong>,
          dovedită pe foaie: categorie vehicul, <strong>scop și loc</strong>, kilometri,
          norma de consum. Scopul trebuie să fie concret și legat de activitate.
          „Deplasare serviciu", „interes profesional", „diverse" sunt formulări pe care
          inspectorii le resping.
        </p>
        <p>
          Naveta de la domiciliu la locul de muncă e, în viața obișnuită, un traseu al
          persoanei, nu al clientului. De aceea interpretarea ANAF tratează tur–returul{" "}
          <strong>casă–serviciu</strong> ca <strong>scop personal</strong>, dacă nu e
          parte dintr-un traseu de lucru (pleci de acasă direct la client, la bancă, la
          șantier, la o instituție).
        </p>

        <h2>PFA cu sediul la domiciliu</h2>
        <p>
          Dacă PFA-ul are <strong>sediul declarat la domiciliu</strong>, „drumul până la
          birou" nu există ca navetă separată: lucrezi de acolo. Problema casă–sediu{" "}
          <strong>nu apare</strong> în aceeași formă. Rămân celelalte trasee: vizită
          client, ANAF, bancă, furnizor. Ele trebuie scrise concret, nu „plecare de
          acasă".
        </p>
        <p>
          Alimentările și kilometrii de weekend sau de vacanță tot trebuie judecate: dacă
          mașina e și mașina familiei, 100% rămâne greu de apărat.{" "}
          <Link to="/foi-parcurs-pfa">Ghidul PFA</Link> spune explicit: combustibil în
          vacanță, fără trasee economice, ridică suspiciuni; mai sigur e regimul de 50%.
        </p>

        <h2>PFA sau SRL cu sediu separat</h2>
        <p>
          Aici apare naveta. Recomandarea practică, dacă totuși ții evidența pentru 100%,
          este să <strong>nu lași gol</strong> segmentul, dar nici să-l deghizezi. Îl
          treci pe foaie cu scop <strong>clar</strong>, de exemplu pornirea sau închiderea
          programului de lucru, și ești conștient că inspectorul îl poate recalifica.
        </p>
        <p>
          Mai robust: evidențiezi zilele în care de acasă <strong>nu te oprești la
          sediu</strong>, ci mergi la o destinație de activitate. „Vizită client SC Alpha
          SRL, str. X — discuție proiect" e un scop. „Casă–sediu" repetat de 22 de ori pe
          lună, fără alt traseu, arată uz de navetă.
        </p>

        <h3>Cum se citesc traseele la control</h3>
        <div className="article-doc__table-wrap">
          <table className="article-doc__table">
            <thead>
              <tr>
                <th>Pe foaie</th>
                <th>Cum se citește de obicei</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Domiciliu → client / furnizor / instituție, cu scop concret</td>
                <td>Traseu de lucru; poate susține 100%, dacă restul dosarului ține</td>
              </tr>
              <tr>
                <td>Domiciliu → sediu, apoi sediu → client în aceeași zi</td>
                <td>
                  Segmentul către client e de lucru; naveta până la sediu rămâne sensibilă
                </td>
              </tr>
              <tr>
                <td>Domiciliu → sediu, tur–retur, în fiecare zi, fără alte destinații</td>
                <td>Navetă; slăbește pretenția de utilizare exclusiv economică</td>
              </tr>
              <tr>
                <td>„Deplasare serviciu" / „diverse" pe același traseu</td>
                <td>Formulare vagă; se respinge indiferent de km</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h2>Ce caută inspectorul, dincolo de un rând pe foaie</h2>

        <h3>Utilizator unic, distanță mare</h3>
        <p>
          Un singur utilizator care locuiește departe de sediu, fără evidență a navetei
          personale, ridică întrebări. Cine acoperă costul drumului?
        </p>

        <h3>Weekend-uri și vacanțe</h3>
        <p>
          Perioade acoperite doar cu „deplasare serviciu" vagă, fără clienți sau
          instituții concrete. Mașina pare folosită personal.
        </p>

        <h3>Trasee fără legătură cu activitatea</h3>
        <p>
          Drumuri spre mall, școală, zone rezidențiale, fără legătură cu clienții sau
          cu obiectul activității firmei.
        </p>

        <h3>Kilometri de navetă care umplu luna</h3>
        <p>
          Casă–birou repetat zilnic, iar contractele și facturile nu arată deplasări
          reale la clienți sau furnizori.
        </p>

        <p>
          Dacă folosești mașina mixt — acasă, copii, cumpărături, plus câțiva clienți —{" "}
          <strong>50% e adesea calea mai sigură</strong>. Nu cere foaie. Nu pretinzi
          exclusivitate. 100% cere dosar: foaie, (la SRL) regulament care interzice uzul
          personal, bonuri care se leagă de km. Un regulament care interzice naveta, dar
          foaia e plină de casă–sediu, se contrazice singur.
        </p>

        <h2>Cum formulezi scopul, dacă segmentul trebuie să apară</h2>
        <p>
          Evită etichetele goale. Dacă pornești activitatea de la domiciliu și mergi la o
          întâlnire: scrie destinația și motivul, nu „plecare de acasă". Dacă te întorci
          de la client fără să treci pe la sediu: același principiu. Dacă singurul drum e
          domiciliu–sediu, pune-ți întrebarea <strong>înainte</strong> de a bifa 100%: mai
          e exclusiv economic, sau e mixt?
        </p>
        <div className="article-doc__callout article-doc__callout--warning">
          <strong>De evitat</strong>
          <p>
            Să „umpli" foaia cu curse casă–birou ca să iasă consumul. Să copiezi 12 luni
            identice. Să treci scop personal (școală, mall) ca interes de serviciu. ANAF
            compară foaia cu facturi, bonuri, contracte — nu doar cu tabelul tău.
          </p>
        </div>

        <h2>Concluzie</h2>
        <p>
          Casă–serviciu nu e un rând inofensiv. E testul uzului mixt. La PFA cu sediu
          acasă, naveta dispare; rămân traseele reale de activitate. La sediu separat,
          tur–returul repetat slăbește 100%. Foaia trebuie să arate{" "}
          <strong>unde s-a lucrat</strong>, nu doar că mașina a pornit dimineața.
        </p>
        <p>
          Detaliile de obligații PFA, model de foaie și cele 4 elemente rămân în ghidurile
          deja publicate. Articolul de față e doar despre <strong>navetă</strong>. Dacă
          mașina e pe persoană fizică,{" "}
          <Link to="/foi-parcurs-comodat">comodatul</Link> e altă ușă — fără el, nici
          discuția despre casă–birou nu începe.
        </p>
        <RelatedGuides currentPath="/foaie-parcurs-casa-serviciu" />
      </ArticleLayout>
    </>
  );
}
